import isEmpty from 'lodash.isempty';
import {
    FETCH_CHECKPOINTS,
    SAVE_CHECKPOINT,
    FETCH_ALL_OBSERVATIONS,
} from '../../actionTypes/shared/apiActionTypes';
import { FETCH_READING_OBSERVATIONS } from '../../actionTypes/reading/apiActionTypes';
import { LICENSE } from '../../../constants/reading/CommonConstants';
import { URL } from '../../../constants/reading/ApiConstants';
import DecodingClient from '../../clients/reading/DecodingClient';
import ObservationsClient from '../../clients/shared/ObservationsClient';
import { apiActionCreator, multyApiCallActionCreator } from '../../actionCreators';
import config from '../../../configs/reading';
import { SUPPORTED_GRADES } from '../../../constants/shared/GradesConstants';

export const fetchObservations = () => async (dispatch, getState) => {
    const state = getState();
    const { selectors } = config.root;
    const { licensingInfo } = selectors.getCommonData(state);
    const apiCallsConfig = {
        [FETCH_READING_OBSERVATIONS.D8]: () =>
            licensingInfo.includes(LICENSE.D8) &&
            ObservationsClient.getObservations(URL.D8_OBSERVATIONS_URL),
        [FETCH_READING_OBSERVATIONS.DECODING]: () =>
            licensingInfo.includes(LICENSE.EXPRESS) && DecodingClient.getObservations(),
    };
    await multyApiCallActionCreator(dispatch, apiCallsConfig, FETCH_ALL_OBSERVATIONS);
};

export const saveCheckPoint = client => async (dispatch, getState) => {
    const { selectors } = config.root;
    const state = getState();
    const additionalApiParams = {
        apiParams: [
            selectors.getUserId(state),
            selectors.getSchoolId(state),
            selectors.getClassOrGroupId(state),
            selectors.getSelectedInstructionGrade(state),
            selectors.getInstructionPeriod(state),
        ],
    };
    await apiActionCreator(dispatch, SAVE_CHECKPOINT, client.saveCheckPoint, additionalApiParams);
};

export const processCheckPoints = client => async (dispatch, getState) => {
    const { selectors } = config.root;
    const state = getState();
    const additionalApiParams = {
        apiParams: [
            selectors.getUserId(state),
            selectors.getSchoolId(state),
            selectors.getClassOrGroupId(state),
        ],
        afterApiCallCalback: () => {
            const selectedGradeCheckPoint = selectors.getSelectedGradeCheckPointObject(getState());
            const selectedGrade = selectors.getSelectedInstructionGrade(getState());
            const isSecure = selectors.isSecureResultFound(getState());
            if (
                isEmpty(selectedGradeCheckPoint.dates) &&
                SUPPORTED_GRADES.includes(selectedGrade) &&
                !isSecure
            ) {
                dispatch(saveCheckPoint(client));
            }
        },
    };
    await apiActionCreator(dispatch, FETCH_CHECKPOINTS, client.getCheckPoints, additionalApiParams);
};
